module.exports = __webpack_public_path__ + "static/media/godfrey.65c21a43.glb";